import {UserPermission} from "../../model/user/UserPermission";
import {DropDownRouteData} from "./HeaderRoutes";

export interface AdminMenuRoutes {
	/**
	 * Label to display.
	 */
	label: string,
	/**
	 * Main rote store to highlight header menu item.
	 */
	route: string,
	/**
	 * Admin platform settings menu.
	 */
	platformSettings: DropDownRouteData[],
	/**
	 * Admin job settings menu.
	 */
	jobSettings: DropDownRouteData[],
	/**
	 * Admin asset settings menu.
	 */
	assetSettings: DropDownRouteData[],
	/**
	 * Permissions allowed for route
	 */
	allowedPermissions?: string[]
}

/**
 * Workspace routes configuration for top header navigation.
 */
export const AdminMenuRoutes: AdminMenuRoutes = {
	label: "Admin",
	route: "/app/admin",
	platformSettings: [
		{
			label: "Users",
			route: "/app/admin/users",
			allowedPermissions: [UserPermission.AdminAll, UserPermission.AdminUsers]
		},
		{
			label: "Brands",
			route: "/app/admin/brands",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Partner Brands",
			route: "/app/admin/partnerbrands",
			allowedPermissions: [UserPermission.AdminAll, UserPermission.AdminPartnerBrands]
		},
		{
			label: "Partner Brand custom fields",
			route: "/app/admin/partnerbrandcustomfields",
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Acquisition channels",
			route: "/app/admin/channels",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Manage postcodes",
			route: "/app/admin/postcodes",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Manage finance products",
			route: "/app/admin/financeproducts",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Show Codat errors",
			route: "/app/admin/codaterrors",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Show Codat operation errors",
			route: "/app/admin/codatoperationerrors",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Show Xero operation errors",
			route: "/app/admin/xerooperationerrors",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Utilities",
			route: "/app/admin/utilities",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Master Regs Catalog",
			route: "/app/admin/masterregscatalog",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Historical Jobs",
			route: "/app/admin/historicaljobs",
			allowedPermissions: [UserPermission.AdminAll]
		}
	],
	jobSettings: [
		{
			label: "Lead types",
			route: "/app/admin/leadtypes",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Lead custom fields",
			route: "/app/admin/leadcustomfields",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Lead sidebar config",
			route: "/app/admin/leadsidebarconfig",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Job types",
			route: "/app/admin/jobtypes",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Job custom fields",
			route: "/app/admin/jobcustomfields",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Job sidebar config",
			route: "/app/admin/jobsidebarconfig",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Categories",
			route: "/app/admin/categories",
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Manage Lead statuses",
			route: "/app/admin/leadstatuses",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Lead status config",
			route: "/app/admin/leadstatuses/config",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Manage Job statuses",
			route: "/app/admin/jobstatuses",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Manage tasks",
			route: "/app/admin/tasks",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Manage mobile surveys",
			route: "/app/admin/activity",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Bulk Job Management",
			route: "/app/admin/bulkjobmanagement",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
	],
	assetSettings: [
		{
			label: "Assets",
			route: "/app/admin/assets",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Asset categories",
			route: "/app/admin/assetcategories",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Manage assets",
			route: "/app/admin/manageassets",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Merchants",
			route: "/app/admin/merchants",
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Materials",
			route: "/app/admin/materials",
			//TODO: apply proper permissions
			allowedPermissions: [UserPermission.AdminAll]
		},
		{
			label: "Manage Graham parts",
			route: "/app/admin/parts/graham",
			allowedPermissions: [UserPermission.AdminAll]
		}

	],
	allowedPermissions: [UserPermission.AdminUsers, UserPermission.AdminPartnerBrands, UserPermission.AdminAll,
		UserPermission.AdminMerchantBranchLocations]
};
